import { EventDetail, EventHeader, EventLayout } from 'features/events';
import { useFeedbackOptions } from '../../../hooks';
import { useNavigateToCalendar, useNavigateToEventDetail } from '../../hooks';

type P = {
  eventId: string;
};

const EventDetailContent = ({ eventId }: P) => {
  const feedbackOptions = useFeedbackOptions();
  const navigateToCalendar = useNavigateToCalendar();
  const navigateToEventDetail = useNavigateToEventDetail();

  return (
    <EventLayout
      eventId={eventId}
      header={({ event }) => (
        <EventHeader
          event={event}
          navigateToCalendar={navigateToCalendar}
          navigateToEventDetail={navigateToEventDetail}
        />
      )}
    >
      {({ event }) => <EventDetail event={event} feedbackOptions={feedbackOptions} />}
    </EventLayout>
  );
};

export default EventDetailContent;
